import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-data-date[date]',
  templateUrl: './report-data-date.component.html',
  styleUrls: ['./report-data-date.component.scss']
})
export class ReportDataDateComponent implements OnInit {
  @Input() date: number | Date | null = 0;
  constructor() {}

  ngOnInit(): void {}
}
